import React from 'react';
import { PlayIcon, InfoIcon } from 'lucide-react';
interface MovieHeroProps {
  onPlay: () => void;
}
export const MovieHero = ({
  onPlay
}: MovieHeroProps) => {
  return <div className="relative h-[90vh] w-full" data-id="element-301">
      <div className="absolute inset-0" data-id="element-302">
        <img src="https://images.unsplash.com/photo-1685164014503-0702f159cb40" alt="The Batman" className="w-full h-full object-cover" data-id="element-303" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#141414] via-[#14141480] to-transparent" data-id="element-304" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#141414] via-[#14141480] to-transparent" data-id="element-305" />
      </div>
      <div className="relative z-10 h-full flex flex-col justify-center px-20" data-id="element-306">
        <div className="flex items-center space-x-3 mb-4" data-id="element-307">
          <span className="text-green-500 font-bold" data-id="element-308">98% Match</span>
          <span className="border px-2 py-0.5" data-id="element-309">PG-13</span>
          <span data-id="element-310">2022</span>
          <span className="border px-2 py-0.5" data-id="element-311">4K Ultra HD</span>
        </div>
        <h1 className="text-7xl font-bold mb-4" data-id="element-312">The Batman</h1>
        <p className="text-xl text-gray-300 max-w-xl mb-8 line-clamp-3" data-id="element-313">
          When the Riddler, a sadistic serial killer, begins murdering key
          political figures in Gotham, Batman is forced to investigate the
          city's hidden corruption and question his family's involvement.
        </p>
        <div className="flex space-x-4" data-id="element-314">
          <button onClick={onPlay} className="flex items-center px-8 py-3 bg-white text-black rounded hover:bg-opacity-90 transition-colors font-semibold" data-id="element-315">
            <PlayIcon className="w-6 h-6 mr-2" data-id="element-316" />
            Play
          </button>
          <button className="flex items-center px-8 py-3 bg-gray-500 bg-opacity-50 text-white rounded hover:bg-opacity-40 transition-colors font-semibold" data-id="element-317">
            <InfoIcon className="w-6 h-6 mr-2" data-id="element-318" />
            More Info
          </button>
        </div>
      </div>
    </div>;
};